import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { KSendSuccessResponse } from '@asset-metrix/portal-gateway-client-js';
import { AsyncNotification } from '@asset-metrix/portal-ui';
import { NotificationData } from '@mantine/notifications';

export async function actionWithAsyncNotification(
  action: () => void | Promise<void | KSendSuccessResponse>,
  {
    startMessage,
    successMessage,
    errorMessage,
    onSuccess,
    onFinished,
    showBackLink = false,
  }: {
    // in progress message
    startMessage?: NotificationData['message'];
    // success message
    successMessage: NotificationData['message'];
    // error message
    errorMessage:
      | NotificationData['message']
      | ((error: unknown) => NotificationData['message']);
    // append back link to error message
    showBackLink?: boolean;
    // on success callback (e.g. table data reload)
    onSuccess?: () => void;
    // on finished callback. Will be called regardless if the action was successful or errored
    onFinished?: () => void;
  }
) {
  const goToPage = globalThis.location.href;

  // If start message is given, further state changes reuse
  // notification instead of creating new ones
  const id = startMessage
    ? AsyncNotification.show(
        {
          message: startMessage,
        },
        'loading'
      )
    : undefined;

  try {
    await action();
    AsyncNotification.show(
      {
        id,
        message: successMessage,
      },
      'success'
    );
    await onSuccess?.();
  } catch (error) {
    AsyncNotification.show(
      {
        id,
        message: (
          <span>
            {typeof errorMessage === 'function'
              ? errorMessage(error)
              : errorMessage}
            {showBackLink && (
              <p>
                <b>
                  -{'>'}{' '}
                  <Link to={goToPage}>
                    <Trans i18nKey="app.notifications.goToPage" />
                  </Link>
                </b>
              </p>
            )}
          </span>
        ),
      },
      'error'
    );
  } finally {
    await onFinished?.();
  }
}
